import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Markdown from 'react-markdown';
import { Icon } from '../';
import cx from 'classnames';
import './styles.scss';

export default class InfoButton extends Component {
  static propTypes = {
    content: PropTypes.string,
  };

  render() {
    const { content, white, blue, red } = this.props;

    const classname = cx('info-button-icon', {
      'white-background': white,
      'blue-background': blue,
      'red-background': red,
    });
    const popoverClass = ['popover-content'];

    if (!content || !content.replace(/[^a-zA-Z0-9_ ]/g, '')) {
      return <span />;
    }

    const popoverContent = (
      <Popover
        className={popoverClass.join(' ')}
        id={Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, '')
          .substr(0, 15)}
      >
        <Markdown source={content} />
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" overlay={popoverContent} rootClose>
        <div className={classname}>
          <Icon name="info-circle" />
        </div>
      </OverlayTrigger>
    );
  }
}
